/**
 * Entry point de la página /general/ (Datos Generales).
 *
 * Es una página standalone — no comparte estado en memoria con la página
 * de Ventas (cada una corre en su propio document). Lo que comparten:
 *   - El módulo state.js (cargado en cada página por separado)
 *   - localStorage (config, hoja activa, etc.)
 *   - Las hojas detectadas en Google Sheets vía sheetsList.fetchSheetsList
 */

import './styles/main.css';

import { state } from './state.js';
import { $ } from './utils/dom.js';
import { setLiveDot, flashLive } from './ui/header.js';
import { bindSettingsButton } from './ui/settingsModal.js';
import { fetchSheetsList, splitSheets } from './api/sheetsList.js';
import { bindGeneralView, activateGeneralView, refreshGeneralView, renderGeneralView } from './views/general.js';
import { renderCurrencyToggle, bindCurrencyToggle, renderRateLabel, CURRENCY_CHANGED_EVENT } from './ui/currencyToggle.js';
import { fetchRates } from './api/exchangeRate.js';

// ─── Header ─────────────────────────────────────────────────────────────
bindSettingsButton();
setLiveDot('loading');

// ─── Moneda (toggle MXN/USD + tasa de cambio) ───────────────────────────
renderCurrencyToggle();
renderRateLabel();
bindCurrencyToggle();
window.addEventListener(CURRENCY_CHANGED_EVENT, renderGeneralView);
fetchRates().then(() => { renderRateLabel(); renderGeneralView(); }).catch(() => {});

// ─── Vista ──────────────────────────────────────────────────────────────
bindGeneralView();
renderGeneralView(); // shell vacío para no mostrar "—" sin contenedor

// ─── Discovery de hojas (necesario para resolver gids) ──────────────────
async function discoverSheets() {
  try {
    const list = await fetchSheetsList();
    const { salesSheets, costsSheet } = splitSheets(list);
    state.knownSheets = salesSheets;
    state.costsSheet = costsSheet;
  } catch (err) {
    console.warn('No se pudieron detectar las hojas:', err);
  }
}

// ─── Refresh manual + auto ──────────────────────────────────────────────
async function refresh({ silent = false } = {}) {
  if (!silent) setLiveDot('loading');
  try {
    await refreshGeneralView();
    flashLive();
    setLiveDot('live');
    $('lastUpdate').textContent = 'Actualizado: ' + new Date().toLocaleString('es-MX');
  } catch (e) {
    setLiveDot('error');
    console.error(e);
  }
}

$('refreshBtn').onclick = () => refresh({ silent: false });

function startAutoRefresh() {
  setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    refresh({ silent: true });
  }, state.autoRefreshMs);
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') refresh({ silent: true });
});

// ─── Carga inicial ──────────────────────────────────────────────────────
(async () => {
  await discoverSheets();
  await activateGeneralView();
  setLiveDot('live');
  $('lastUpdate').textContent = 'Actualizado: ' + new Date().toLocaleString('es-MX');
  startAutoRefresh();
})();
